export default __webpack_public_path__ + "static/media/caramel-mecchiato-v3.5fb4992c.png";